import {TrDialog} from "../../Models/tr-dialog";
import {ConfirmDialog} from "../../Models/confirm-dialog";

const ConfirmDialogView = require('./confirm-dialog.html');

interface IScope extends ng.IScope {
  resolve: (val: boolean) => void;
  showCancel: boolean;
  message: string;
  dialog: TrDialog;
  cancel: () => void;
  confirm: () => void;
  timeoutHandle: any;
}

export const ConfirmDialogDirective = [
  () => {
    return {
      restrict: 'E',
      scope: {
        instance: '=',
      },
      templateUrl: ConfirmDialogView,
      link: (scope: IScope) => {
        scope.dialog = new TrDialog();

        scope.$watch('instance', (value: ConfirmDialog) => {
          value.open = (message: string, showCancel: boolean, timeout?: number) => {
            scope.message = message;
            scope.showCancel = showCancel;

            if(timeout > 0) {
              scope.timeoutHandle = setTimeout(() => {
                scope.confirm();
              }, timeout);
            }

            return new Promise<boolean>(resolve => {
              scope.dialog.open();
              scope.resolve = resolve;
            });
          };
        });

        scope.cancel = () => {
          clearTimeout(scope.timeoutHandle);
          scope.dialog.close();
          scope.resolve(false);
        };

        scope.confirm = () => {
          clearTimeout(scope.timeoutHandle);
          scope.dialog.close();
          scope.resolve(true);
        };
      },
    }
  }
];